var _jsxFileName = "/codebuild/output/src2464868119/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/steps/RegisterAdultAccount.tsx";
import React from 'react';
import { FormContainer, Input, InputPassword, PasswordInputValidator, PhoneInput } from 'Components/utility';
import i18n from 'Utilities/i18n';
import { ContentContainer } from '../helpers';
function RegisterAdultAccount({
  formikForm,
  passwordRules,
  showPhoneInput,
  onValidate
}) {
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange
  } = formikForm;
  return /*#__PURE__*/React.createElement(ContentContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FormContainer, {
    hasHiddenUserInput: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.label'),
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.label'),
    errorMessage: errors.email,
    isInvalid: errors.email && touched.email ? true : false,
    testID: "email",
    value: values.email,
    onChangeText: handleChange('email'),
    onBlur: handleBlur('email'),
    inputMode: "email",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 9
    }
  }), showPhoneInput && /*#__PURE__*/React.createElement(PhoneInput, {
    "aria-label": i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.label'),
    errorMessage: errors.mobileNumber,
    isInvalid: errors.mobileNumber && touched.mobileNumber ? true : false,
    testID: "mobileNumber",
    value: values.mobileNumber,
    onChangeText: handleChange('mobileNumber'),
    onBlur: handleBlur('mobileNumber'),
    maxLength: 15,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(PasswordInputValidator, {
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.password.label'),
    errors: errors,
    touched: touched,
    onChangeText: handleChange('password'),
    handleBlur: handleBlur('password'),
    password: values.password,
    onValidate: onValidate,
    passwordRules: passwordRules,
    testID: "password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(InputPassword, {
    placeholder: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.placeholder'),
    label: i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.label'),
    isInvalid: errors.confirmPassword && touched.confirmPassword ? true : false,
    errorMessage: errors.confirmPassword,
    testID: "confirmPassword",
    onChangeText: handleChange('confirmPassword'),
    onBlur: handleBlur('confirmPassword'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 9
    }
  })));
}
export { RegisterAdultAccount };